// Import direto via caminho relativo dentro do pacote policy
import FormValidation from '@plone/volto/helpers/FormValidation/FormValidation';
import config from '@plone/volto/registry';

// Mantemos uso apenas de FormValidation para alinhar à lógica do TabsValidator.

/**
 * Valida blocos do tipo accordion e seus filhos recursivamente.
 * Retorna erros no formato { [blockId]: erros }.
 */
export function validateAccordionBlock({ schema, formData, formatMessage }) {
  // Segue a mesma lógica do TabsValidator: só processa se o root for o bloco alvo.
  if (!formData || formData['@type'] !== 'accordion') return {};

  const errors = {};
  validateAccordionBlockRecursive({
    block: formData,
    schema,
    formatMessage,
    errors,
    blockId: formData.id || formData['@id'] || 'accordion',
  });
  return errors;
}

function validateAccordionBlockRecursive({
  block,
  schema,
  formatMessage,
  errors,
  blockId,
}) {
  if (!block) return;

  // Se for accordion ou painel, valida seus filhos recursivamente.
  if (block['@type'] === 'accordion' || block['@type'] === 'accordionPanel') {
    const children = getAccordionChildren(block);
    children.forEach(({ childBlock, childId }) => {
      if (!childBlock) return;
      // Caso seja um container anônimo (objeto com blocks + blocks_layout)
      if (
        !childBlock['@type'] &&
        childBlock.blocks &&
        childBlock.blocks_layout
      ) {
        getAccordionChildren(childBlock).forEach(
          ({ childBlock: grandChild, childId: grandChildId }) => {
            if (grandChild) {
              const grandChildSchema = getBlockSchema(grandChild, {
                formatMessage,
              });
              validateAccordionBlockRecursive({
                block: grandChild,
                schema: grandChildSchema,
                formatMessage,
                errors,
                blockId: grandChildId,
              });
            }
          },
        );
      } else {
        // Bloco de conteúdo ou outro accordion/painel
        const childSchema = getBlockSchema(childBlock, { formatMessage });
        validateAccordionBlockRecursive({
          block: childBlock,
          schema: childSchema,
          formatMessage,
          errors,
          blockId: childId,
        });
      }
    });
  } else if (block['@type']) {
    // Validação de blocos de conteúdo (teaser, slate, etc)
    const validationErrors = FormValidation.validateFieldsPerFieldset({
      schema: schema || getBlockSchema(block, { formatMessage }),
      formData: block,
      formatMessage,
    });
    if (Object.keys(validationErrors).length > 0) {
      errors[blockId] = validationErrors;
    }
  }
}

/**
 * Retorna os filhos de um bloco accordion (blocks + blocks_layout).
 */
function getAccordionChildren(block) {
  const data = block.data || block;
  const blocks = data.blocks;
  const blocksLayout = data.blocks_layout;
  if (!blocks || !blocksLayout) return [];
  return blocksLayout.items.map((childId) => ({
    childBlock: blocks[childId],
    childId,
  }));
}

/**
 * Recupera o schema do bloco.
 */
function getBlockSchema(blockFormData, intl) {
  const defaultSchema = {
    properties: {},
    fieldsets: [],
    required: [],
  };
  const blockType = blockFormData['@type'];
  const blockSchema =
    config.blocks.blocksConfig[blockType]?.blockSchema || defaultSchema;

  return typeof blockSchema === 'function'
    ? blockSchema({ intl, formData: blockFormData })
    : blockSchema;
}
